import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import classNames from "classnames/bind";
import PropTypes from "prop-types";
import { Container, Row, Col, Button, Jumbotron } from "reactstrap";
import InfiniteScroll from 'react-infinite-scroller';
import pluralize from "pluralize";
import { getCookie } from "~/utils/cookie";
import assetPath from "~/utils/assetPath";
import {
  pictureContainer
} from "./helpers/elements";
import { isGamedistributionApp } from "~/utils/misc";

import styles from "./styles.scss";

class Collection extends React.Component {
  static propTypes = {
    id: PropTypes.string
  }
  static contextTypes = {
    fetch: PropTypes.func.isRequired
  };

  constructor(props) {
    // Set props
    super(props);

    // Set initial state
    this.state = {
      isLoadingPictures: false,
      hasMorePictures: true,
      picturePage: 1,
      pictures: [],
      collection: {}
    };

    // Bind element functions
    this.pictureContainer = pictureContainer.bind(this);
  }

  //-----------------------------------------------------------------------
  // Lifecycle
  //-----------------------------------------------------------------------
  componentDidMount() {
    this.loadCollection()
    this.loadPictures()
  }

  shouldComponentUpdate() {
    return false;
  }

  //-----------------------------------------------------------------------
  // Handlers
  //-----------------------------------------------------------------------
  handleBottomReached = () => {
    this.loadPictures()
  };

  handleLinkClick = event => {
    if (isGamedistributionApp()) {
      event.preventDefault();
      window.parent.postMessage({ event: "handleLinkClick", link: `${$(event.target).attr("data-href")}?platform=gamedistribution` }, "*")
    }
  }

  //-----------------------------------------------------------------------
  // Helpers
  //-----------------------------------------------------------------------
  loadCollection = () => {
    this.context.fetch(`/api/unsplash/collections/${this.props.id}`).then(response => response.json()).then((json) => {
      this.setState({ collection: json })
      this.forceUpdate();
    });
  };

  loadPictures = () => {
    if (is.truthy(this.state.isLoadingPictures)) {
      return
    }

    this.state.isLoadingPictures = true

    this.context.fetch(`/api/unsplash/collections/photos/${this.props.id}?page=${this.state.picturePage}&perPage=${18}`).then(response => response.json()).then((json) => {
      this.setState({ picturePage: this.state.picturePage + 1, hasMorePictures: is.equal(json.length, 18), pictures: _.concat(this.state.pictures, json) })
      this.forceUpdate();

      _.delay(() => {
        $("#app").perfectScrollbar("update");
      }, 0)

      _.delay(() => {
        this.setState({ isLoadingPictures: false })
        this.forceUpdate();
      }, 160)
    });
  };

  //-----------------------------------------------------------------------
  // Render
  //-----------------------------------------------------------------------
  render() {
    return (
      <div id="collection_component">
        <Container id="headline_container">
          <Row>
            <Col>
            <div className="float-left">
              <h1>{is.existy(this.state.collection.total_photos) ? this.state.collection.title : ''}</h1>
            </div>
            <div className="collection_type_container float-right">
              <h4 className="float-right">{is.existy(this.state.collection.total_photos) ? pluralize('puzzle', this.state.collection.total_photos, true) : ''}</h4>
            </div>
            </Col>
          </Row>
        </Container>

        <Container id="pictures">
          <InfiniteScroll
            pageStart={0}
            loadMore={this.handleBottomReached}
            hasMore={this.state.hasMorePictures}
            loader={<Row key={0}><Col><p className="picture_loader" key={0}>{is.above(this.state.pictures.length, 0) && is.truthy(this.state.hasMorePictures) ? 'Loading puzzles' : ''}</p></Col></Row>}
            useWindow={false}
            getScrollParent={() => document.getElementById("app")}
            threshold={128}
            initialLoad={false}
            >
            <Row>
              <Col xs="12" sm="6" md="4">
                <For each="item" index="idx" of={_.filter(this.state.pictures, (o, i) => (i + 1 - 1) % 3 == 0 )}>
                  {this.pictureContainer(item, idx)}
                </For>
              </Col>
              <Col xs="12" sm="6" md="4">
                <For each="item" index="idx" of={_.filter(this.state.pictures, (o, i) => (i + 1 - 2) % 3 == 0 )}>
                  {this.pictureContainer(item, idx)}
                </For>
              </Col>
              <Col xs="12" sm="6" md="4">
                <For each="item" index="idx" of={_.filter(this.state.pictures, (o, i) => (i + 1) % 3 == 0 )}>
                  {this.pictureContainer(item, idx)}
                </For>
              </Col>
            </Row>
          </InfiniteScroll>
        </Container>
      </div>
    );
  }
}

export default withStyles(styles)(Collection);



// WEBPACK FOOTER //
// ./src/routes/collections/components/CollectionComponent/index.js